/**
 * Fabrix Read More — Progressive enhancement for long collection descriptions.
 * Truncates text beyond a configurable character limit and adds a toggle.
 */
if (!customElements.get('fabrix-read-more')) {
  class FabrixReadMore extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('[data-read-more-content]');
      if (!this.content) return;

      this.limit = parseInt(this.dataset.limit || '150', 10);
      const full = this.content.innerHTML.trim();
      const text = this.content.textContent.trim();

      if (text.length <= this.limit) return;

      this.fullHTML = full;
      this.truncated = text.substring(0, this.limit).replace(/\s+\S*$/, '') + '…';

      this.content.textContent = this.truncated;

      this.toggle = document.createElement('button');
      this.toggle.className = 'fabrix-read-more__toggle';
      this.toggle.textContent = 'Read more';
      this.toggle.type = 'button';
      this.toggle.addEventListener('click', () => this.handleToggle());
      this.content.after(this.toggle);

      this.expanded = false;
    }

    handleToggle() {
      this.expanded = !this.expanded;
      if (this.expanded) {
        this.content.innerHTML = this.fullHTML;
        this.toggle.textContent = 'Read less';
      } else {
        this.content.textContent = this.truncated;
        this.toggle.textContent = 'Read more';
      }
    }
  }

  customElements.define('fabrix-read-more', FabrixReadMore);
}
